import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Firestore } from '@angular/fire/firestore';
import type { CreateUserActionEventPayload } from '../../data-access/user-activity-logs';
import { createUsersActivity$, } from '../../data-access/user-activity-logs';
import { selectCurrentUser } from '../../current-user/store/current-user.selectors';
import { filter, take } from 'rxjs/operators';
import { inputIsNotNullOrUndefined } from '../../data-access/input-is-not-null-or-undefined';

@Injectable({
  providedIn: 'root',
})
export class CreateUserActivityLogService {
  constructor(private firestore: Firestore, private store$: Store) {
  }

  create(payload: CreateUserActionEventPayload): Observable<boolean> {
    return this.store$.pipe(
      select(selectCurrentUser),
      filter(inputIsNotNullOrUndefined),
      take(1),
      switchMap(currentUser =>
        createUsersActivity$(this.firestore, currentUser.accountId, currentUser.userId, payload)
      ),
    );
  }
}
